import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  ListItem,
  Typography,
  ListItemIcon,
  Paper,
  ListItemText,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import * as React from 'react'
import TopicTypeIcon from '../../../Courses/TopicTypeIcon'
import { ICourse, ICourseLessonContent } from '../../../../interfaces/ICourse'
import BookIcon from '@mui/icons-material/Book'

export default function LessonExpansionComponent(props: {
  courseLessonContents: Array<ICourseLessonContent>
  courseDetails: ICourse
}) {
  const [expandedIndex, setExpandedIndex] = React.useState(
    -1,
    // props.courseLessonContents?.length ? 0 : -1
  )

  return (
    <div>
      <div style={{ width: '100%' }}>
        {props.courseLessonContents.map((lesson, index) => {
          return (
            <Accordion
              variant={'outlined'}
              style={{
                margin: '5px 0px',
                // backgroundColor: '#212330',
              }}
              expanded={expandedIndex === index}
              key={lesson?._id || index}
              onChange={(_event: object, expanded: boolean) => {
                if (expanded) {
                  setExpandedIndex(index)
                } else {
                  setExpandedIndex(-1)
                }
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="lessons"
                id="lessons"
              >
                <ListItem
                  style={{
                    marginTop: '0px',
                    justifyContent: 'space-between',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <ListItemIcon
                      style={{
                        width: '30px',
                        minWidth: '30px',
                        // color: '#fafafa',
                      }}
                    >
                      <BookIcon fontSize={'small'} />
                    </ListItemIcon>

                    <ListItemText>
                      <Typography
                        variant={'body2'}
                        style={{
                          maxWidth: '160px',
                          wordBreak: 'break-word',
                          // color: '#fafafa',
                          // fontWeight: "bold",
                        }}
                      >
                        {lesson?.name || 'No module'}
                      </Typography>
                    </ListItemText>
                  </div>
                  <div>
                    <ListItemText>
                      <Typography
                        style={{ color: '#fafafa85' }}
                        variant={'body2'}
                      >
                        {lesson?.contents?.length} content
                      </Typography>
                    </ListItemText>
                  </div>
                </ListItem>
              </AccordionSummary>

              <AccordionDetails
                style={{
                  width: '100%',
                  display: 'block',
                  padding: '0 12px',
                }}
              >
                <div>
                  {lesson.contents.map((topic: any, topicIndex: number) => {
                    return (
                      <Paper
                        variant={'outlined'}
                        style={{
                          borderRadius: '10px',
                          margin: '5px 0px',
                          // backgroundColor: '#1a1c1e',
                          // color: '#fff',
                        }}
                      >
                        <ListItem divider={false} key={topic._id}>
                          <Typography
                            style={{ marginRight: '8px' }}
                            variant="body2"
                          >
                            {topicIndex + 1}.
                          </Typography>
                          <ListItemIcon style={{ minWidth: '25px' }}>
                            <TopicTypeIcon
                              color="primary"
                              topic_type={topic.content_type}
                            />
                          </ListItemIcon>
                          <div style={{ maxWidth: '800px' }}>
                            <Typography style={{ wordBreak: 'break-word' }}>
                              {props.courseDetails
                                ?.show_content_title_to_unapproved
                                ? topic.name
                                : '**************'}
                            </Typography>
                            <Typography
                              variant="body2"
                              gutterBottom={true}
                              style={{
                                wordBreak: 'break-word',
                                // color: '#fafafa96',
                              }}
                            >
                              {props.courseDetails
                                ?.show_content_title_to_unapproved
                                ? topic.objectives
                                : '**************'}
                            </Typography>
                          </div>
                        </ListItem>
                      </Paper>
                    )
                  })}
                </div>
              </AccordionDetails>
            </Accordion>
          )
        })}
      </div>
    </div>
  )
}
